<template>
  <div class="user-wrapper">

    <user-filter-form
      @filter="updateTableData"
      v-if="hasRes('user_index')" />

    <custom-table
      v-if="hasRes('user_index')"
      :data="userList"
      @data-change="updateTableData">
      <el-table-column
        prop="userid"
        label="商户ID"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="username"
        label="登录名"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="agent"
        label="代理商"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              代理商ID: {{ scope.row.agents[0].agentid }}<br/>
              代理商: {{ scope.row.agents[0].nickname }}
            </div>
            <span>
              {{ scope.row.agents[0].agentname }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="alias"
        label="商户名称"
        sortable="custom"
        align="center"
        header-align="center">
        <template slot-scope="scope">
          {{ scope.row.alias || '未设置' }}
        </template>
      </el-table-column>

      <el-table-column label="操作"
        align="center"
        width="400"
        header-align="center"
        v-if="hasResCate('dev') || hasResCate('merchant') || hasResCate('store') || hasResCate('wechat_account')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="hasResCate('dev')"
            @click="jumpToDev(scope.row.userid)">设备管理</el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="hasResCate('merchant')"
            @click="jumpToMerchantCpl(scope.row.userid)">入件管理</el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="hasResCate('store')"
            @click="onManageAppClick(scope.row)">应用管理</el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="hasResCate('wechat_account')"
            @click="onWechatAccountClick(scope.row)">公众号管理</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="userCount"
      v-if="hasRes('user_index')"
      @page-change="updateTableData" />

    <dialog-manage-app
      owner-type="user"
      :owner="owner"
      :owner-app-list="userAppList"
      :visible.sync="manageAppDialogVisible"
      @add-app="addUserOrAgentAppDialogVisible = true"
      @edit-app="onAppEditClick"
      @data-change="refreshOwnerApp" />

    <dialog-add-user-or-agent-app
      :owner="owner"
      owner-type="user"
      :existed-owner-app-list="userAppList"
      :visible.sync="addUserOrAgentAppDialogVisible"
      @data-change="refreshOwnerApp" />

    <dialog-edit-user-app
      @data-change="refreshOwnerApp"
      :editing-user-app="editingUserApp"
      :visible.sync="editUserAppDialogVisible" />

    <dialog-wechat-account-setting
      ref="wechatAccountSettingDialog"
      :user="wechatAccountSettingUser"
      @wechat-account-create="onWechatAccountCreateClick"
      @wechat-account-update="onWechatAccountUpdateClick"
      @wechat-account-delete="onWechatAccountDeleteClick"
      @wechat-menu-create="onWechatMenuCreate"
      @wechat-menu-update="onWechatMenuUpdate"
      @wechat-auto-reply-create="onWechatAutoReplyCreateClick"
      @wechat-auto-reply-update="onWechatAutoReplyUpdateClick"
      @wechat-auto-reply-delete="onWechatAutoReplyDeleteClick"
      v-model="wechatAccountSettingDialogVisible" />

    <dialog-wechat-account-editor
      :user="wechatAccountSettingUser"
      :wechat-account="editingWechatAccount"
      :mode="editingWechatAccountMode"
      @submit="onWechatAccountEditSubmit"
      v-model="editingWechatAccountDialogVisible" />

    <dialog-wechat-auto-reply-editor
      :user="wechatAccountSettingUser"
      :wechat-account="editingWechatAccount"
      :wechat-auto-reply="editingWechatAutoReply"
      :mode="editingWechatAutoReplyMode"
      @submit="onWechatAutoReplySubmit"
      v-model="editingWechatAutoReplyDialogVisible" />

    <dialog-wechat-menu-editor
      :user="wechatAccountSettingUser"
      :wechat-account="editingWechatAccount"
      :wechat-menu="editingWechatMenu"
      :mode="editingWechatMenuMode"
      @submit="onWechatMenuSubmit"
      v-model="editingWechatMenuDialogVisible" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import UserFilterForm from '@/components/user/UserFilterForm'
import DialogManageApp from '@/pages/op/store/components/DialogManageApp'
import DialogAddUserOrAgentApp from '@/pages/op/store/components/DialogAddUserOrAgentApp'
import DialogEditUserApp from '@/pages/op/store/components/DialogEditUserApp'
import DialogWechatAccountSetting from './components/DialogWechatAccountSetting.vue'
import DialogWechatAccountEditor from './components/DialogWechatAccountEditor.vue'
import DialogWechatAutoReplyEditor from './components/DialogWechatAutoReplyEditor.vue'
import DialogWechatMenuEditor from './components/DialogWechatMenuEditor.vue'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

import wechatAccountApi from '@/api/wechatAccountApi'
import wechatAutoReplyApi from '@/api/wechatAutoReplyApi'

export default {
  name: 'User',
  components: {
    CustomTable,
    CustomPaginate,
    UserFilterForm,
    DialogManageApp,
    DialogAddUserOrAgentApp,
    DialogEditUserApp,
    DialogWechatAccountSetting,
    DialogWechatAccountEditor,
    DialogWechatAutoReplyEditor,
    DialogWechatMenuEditor
  },
  data () {
    return {
      manageAppDialogVisible: false,
      owner: {},

      addUserOrAgentAppDialogVisible: false,

      editUserAppDialogVisible: false,
      editingUserApp: {},

      wechatAccountSettingDialogVisible: false,
      wechatAccountSettingUser: {},

      editingWechatAccountDialogVisible: false,
      editingWechatAccount: {},
      editingWechatAccountMode: 'create',

      editingWechatAutoReplyDialogVisible: false,
      editingWechatAutoReply: {},
      editingWechatAutoReplyMode: 'create',

      editingWechatMenuDialogVisible: false,
      editingWechatMenu: {},
      editingWechatMenuMode: 'create'
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters',
      'loading'
    ]),
    ...mapState('user', [
      'userList',
      'userCount'
    ]),
    ...mapState('store', [
      'userAppList'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('user', [
      'getUsers'
    ]),
    ...mapActions('store', [
      'getUserApps'
    ]),

    jumpToMerchantCpl (userid) {
      this.$router.push({
        name: 'MerchantInfoSupply',
        query: {
          userid: userid
        }
      })
    },

    jumpToDev (userid) {
      this.$router.push({
        name: 'Device',
        query: {
          userid: userid
        }
      })
    },

    async onManageAppClick (user) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载用户应用',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await this.getUserApps({
          page: 1,
          pageSize: 9999,
          condition: {
            userid: user.userid
          }
        })

        this.owner = user
        this.manageAppDialogVisible = true
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取商户应用失败'
        })
      }
      loading.close()
    },

    // 微信公众号相关事件处理
    onWechatAccountClick (user) {
      this.wechatAccountSettingUser = user
      this.wechatAccountSettingDialogVisible = true
    },

    onWechatAccountCreateClick () {
      this.editingWechatAccountMode = 'create'
      this.editingWechatAccountDialogVisible = true
    },
    onWechatAccountUpdateClick (wechatAccount) {
      this.editingWechatAccount = wechatAccount
      this.editingWechatAccountMode = 'update'
      this.editingWechatAccountDialogVisible = true
    },
    async onWechatAccountDeleteClick (wechatAccount) {
      try {
        wechatAccount.userId = this.wechatAccountSettingUser.userid
        const { rcode, msg } = await wechatAccountApi.deleteWechatAccount(wechatAccount)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }

        this.$message({
          message: '删除微信公众号成功',
          type: 'success'
        })
        this.wechatAccountSettingDialogVisible = false
      } catch (err) {
        console.log(err)
        this.$message({
          message: '删除微信公众号失败',
          type: 'error'
        })
      }
    },
    onWechatAccountEditSubmit (wechatAccount) {
      if (this.editingWechatAccountMode === 'create') {
        this.addWechatAccount(wechatAccount)
      } else {
        this.updateWechatAccount(wechatAccount)
      }
    },

    onWechatMenuCreate (wechatAccount) {
      this.editingWechatAccount = wechatAccount

      this.editingWechatMenuMode = 'create'
      this.editingWechatMenuDialogVisible = true
    },
    onWechatMenuUpdate (wechatAccount, wechatMenu) {
      this.editingWechatAccount = wechatAccount

      this.editingWechatMenu = wechatMenu
      this.editingWechatMenuMode = 'update'
      this.editingWechatMenuDialogVisible = true
    },

    onWechatAutoReplyCreateClick (wechatAccount) {
      this.editingWechatAccount = wechatAccount

      this.editingWechatAutoReplyMode = 'create'
      this.editingWechatAutoReplyDialogVisible = true
    },
    onWechatAutoReplyUpdateClick (wechatAccount, wechatAutoReply) {
      this.editingWechatAccount = wechatAccount

      this.editingWechatAutoReply = wechatAutoReply
      this.editingWechatAutoReplyMode = 'update'
      this.editingWechatAutoReplyDialogVisible = true
    },
    onWechatAutoReplyDeleteClick (wechatAccount, wechatAutoReply) {
      this.deleteWechatAutoReply(wechatAutoReply)
    },
    onWechatAutoReplySubmit (autoReply) {
      if (this.editingWechatAutoReplyMode === 'create') {
        this.addWechatAutoReply(autoReply)
      } else {
        this.updateWechatAutoReply(autoReply)
      }
    },

    onWechatMenuSubmit (menu) {
      this.addWechatAccountMenu(menu)
    },

    async refreshOwnerApp () {
      try {
        await this.getUserApps({
          page: 1,
          pageSize: 9999,
          condition: {
            userid: this.owner.userid
          }
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取商户应用失败'
        })
      }
    },
    onAppEditClick (userApp) {
      this.editingUserApp = userApp
      this.editUserAppDialogVisible = true
    },

    // 添加微信公众号
    async addWechatAccount (wechatAccount) {
      try {
        const { rcode, msg } = await wechatAccountApi.addWechatAccount(wechatAccount)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '添加微信公众号成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatAccountDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getWechatAccount()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '添加微信公众号失败',
          type: 'error'
        })
      }
    },
    // 更新微信公众号
    async updateWechatAccount (wechatAccount) {
      try {
        const { rcode, msg } = await wechatAccountApi.updateWechatAccount(wechatAccount)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '更新微信公众号成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatAccountDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getWechatAccount()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '更新微信公众号失败',
          type: 'error'
        })
      }
    },

    // 添加微信自动回复
    async addWechatAutoReply (wechatAutoReply) {
      try {
        const { rcode, msg } = await wechatAutoReplyApi.addWechatAutoReply(wechatAutoReply)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '添加微信公众号自动回复成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatAutoReplyDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getWechatAutoReplyList()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '添加微信公众号自动回复失败',
          type: 'error'
        })
      }
    },
    // 更新微信自动回复
    async updateWechatAutoReply (wechatAutoReply) {
      try {
        const { rcode, msg } = await wechatAutoReplyApi.editWechatAutoReply(wechatAutoReply)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '更新微信公众号自动回复成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatAutoReplyDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getWechatAutoReplyList()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '更新微信公众号自动回复失败',
          type: 'error'
        })
      }
    },
    async deleteWechatAutoReply (wechatAutoReply) {
      try {
        const { rcode, msg } = await wechatAutoReplyApi.deleteWechatAutoReply(wechatAutoReply)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '删除微信公众号自动回复成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatAccountDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getWechatAutoReplyList()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '删除微信公众号自动回复失败',
          type: 'error'
        })
      }
    },

    async addWechatAccountMenu (wechatMenu) {
      try {
        const { rcode, msg } = await wechatAccountApi.addWechatAccountMenu(wechatMenu)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '添加微信菜单成功',
          type: 'success'
        })
        // 关闭表单弹窗，并更新微信公众号设置弹窗
        this.editingWechatMenuDialogVisible = false
        this.$refs['wechatAccountSettingDialog'].getMenu()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '添加微信公众号菜单失败',
          type: 'error'
        })
      }
    },

    updateTableData () {
      if (!this.hasRes('user_index')) return

      this.setLoading(true)

      this.getUsers({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取商户列表失败'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/op/user/User.vue